import AOS from 'aos'

export const initialise = () => {
    window.addEventListener('load', (event) => {
        const widgets: NodeListOf<HTMLElement> = document.querySelectorAll(
            `.main-content-block > .content-widget .react-snippet-component,
            .main-content-block > .dynamic-widget,
            .main-content-block > .container-widget .react-snippet-component`
        )
        
        widgets.forEach((widget: HTMLElement) => {
            if (widget.classList.contains('react-snippet-component')) {
                widget.setAttribute('data-aos', 'fade-up')
            } else {
                let children = Array.from(widget.children)
                children.forEach((child) => {
                    child?.setAttribute('data-aos', 'fade-up')
                })
            }
        })
        
        document.body.classList.add('loaded')

        setTimeout(() => {
            AOS.init({
                duration: 1000,
                easing: 'ease-in-out',
                once: true,
                offset: 250,
            })
        }, 100)
    })
}
